export default ({ margin, breakPoints }) => ({
    mainLayout: {
        position: 'relative',
        overflow: 'hidden',
    },
    leftLayout: {
        float: 'left',
        width: '100%',
        overflow: 'hidden',
        [breakPoints.double]: {
            width: 'calc(50% - 2px)',
            borderRight: '1px dashed #ddd',
            paddingBottom: 20,
        },
    },
    rightLayout: {
        float: 'left',
        width: '100%',
        overflow: 'hidden',
        [breakPoints.double]: {
            width: '50%',
        },
    },
});
